import { Table, Tag, Typography } from 'antd'
import { useState } from 'react'
import MutantPromptModal from './MutantPromptModal'
import {
  EvalCaseUnits,
  EvalUnitStatus,
  formatPassRate,
  formatUnitPassCount,
  isMutantUnit,
  unitLabel,
  unitStatusColor,
} from './runsAdminModel'

type Props = {
  cases: EvalCaseUnits[]
}

const columns = [
  {
    title: 'Unit',
    key: 'unit',
    render: (_: unknown, unit: EvalUnitStatus) => {
      const label = unitLabel(unit)
      return isMutantUnit(unit) ? (
        // Mutant rows drill into the mutant's prompt text.
        <Typography.Link>{label}</Typography.Link>
      ) : (
        <Typography.Text>{label}</Typography.Text>
      )
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    width: 120,
    render: (status: EvalUnitStatus['status']) => (
      <Tag color={unitStatusColor(status)}>{status}</Tag>
    ),
  },
  {
    title: 'Passed',
    key: 'passed',
    width: 140,
    render: (_: unknown, unit: EvalUnitStatus) =>
      `${formatUnitPassCount(unit)} (${formatPassRate(unit.pass_rate)})`,
  },
]

const RunResults = ({ cases }: Props) => {
  // The drilled-into mutant's source prompt id, or null when nothing is open.
  const [openPromptId, setOpenPromptId] = useState<string | null>(null)

  if (cases.length === 0) {
    return (
      <Typography.Text type="secondary">No results yet.</Typography.Text>
    )
  }

  return (
    <>
      {cases.map((c) => (
        <div key={c.case_version_id} style={{ marginBottom: 16 }}>
          <Typography.Text strong>{c.case_name ?? '—'}</Typography.Text>
          <Table<EvalUnitStatus>
            dataSource={c.units}
            columns={columns}
            rowKey={(unit) => unit.source_prompt_id ?? 'base'}
            size="small"
            pagination={false}
            onRow={(unit) =>
              isMutantUnit(unit)
                ? {
                    onClick: () => setOpenPromptId(unit.source_prompt_id),
                    style: { cursor: 'pointer' },
                  }
                : {}
            }
            style={{ marginTop: 4 }}
          />
        </div>
      ))}
      <MutantPromptModal
        sourcePromptId={openPromptId}
        onClose={() => setOpenPromptId(null)}
      />
    </>
  )
}

export default RunResults
